import React, { useState } from 'react'
import { GlobalStyles } from '@mui/material'
import { notifyError } from '@/components'
import {
  Map,
  Polyline,
  Placemark,
  SearchControl,
  ZoomControl,
} from '@pbe/react-yandex-maps'
import MyPolyLine from '@/modules/maps/components/PolyLine'
import { getIconForUnit } from '@/components/Organisms/Map/Map'

interface StaticLine {
  typeId: number
  coordinates: number[][]
  state: 1 | 2
}

interface MapWithPolylineProps {
  typeId?: number
  defaultCenter: number[]
  defaultZoom: number
  initialCoordinates?: number[][]
  staticPolylines?: any[]
  onCoordinatesChange?: (coordinates: number[][]) => void
  excludeId?: number
  dataUnits?: any
  disabled?: boolean
}
export const getLineColor = (typeId: number): string => {
  switch (typeId) {
    case 1:
      return '#7D8EFF'
    case 2:
      return '#FF920C'
    default:
      return '#808080'
  }
}

const MapLightnings: React.FC<MapWithPolylineProps> = ({
  typeId = 1,
  defaultCenter,
  defaultZoom,
  dataUnits = [],
  initialCoordinates = [],
  staticPolylines = [],
  onCoordinatesChange,
  excludeId,
  disabled,
}) => {
  const [coordinates, setCoordinates] = useState(initialCoordinates)
  const finalStaticPolylines = staticPolylines.filter(
    (line) => line.id !== excludeId
  )
  const handleMapClick = (e: any) => {
    const coords = e.get('coords')
    setCoordinates((prev) => {
      const newCoordinates = [...prev, coords]
      if (newCoordinates.length > 80) {
        notifyError('Нельзя добавлять больше 80 точек')
        return prev
      }
      onCoordinatesChange?.(newCoordinates) // Вызываем callback
      return newCoordinates
    })
  }

  const handlePlacemarkClick = (index: number) => {
    setCoordinates((prev) => {
      const newCoordinates = prev.filter((_, i) => i !== index)
      onCoordinatesChange?.(newCoordinates) // Вызываем callback
      return newCoordinates
    })
  }

  const handleDragEnd = (index: number, newCoords: number[]) => {
    setCoordinates((prev) => {
      const newCoordinates = [...prev]
      newCoordinates[index] = newCoords
      onCoordinatesChange?.(newCoordinates) // Вызываем callback
      return newCoordinates
    })
  }

  const getLightsLocations = dataUnits?.data?.data.filter((item: any) => {
    return item.typeId === 14
  })

  return (
    <Map
      options={{ yandexMapDisablePoiInteractivity: true }}
      modules={['control.ZoomControl', 'geoObject.addon.balloon']}
      defaultState={{
        center: defaultCenter,
        zoom: defaultZoom,
        controls: [],
      }}
      width='100%'
      height='100%'
      onClick={handleMapClick}
    >
      <SearchControl options={{ float: 'left', noPlacemark: true }} />
      <ZoomControl
        options={{
          position: {
            right: 10,
            left: 'auto',
            top: (document.documentElement.scrollHeight - 530) / 2,
            bottom: 'auto',
          },
          // @ts-ignore
          float: 'right',
        }}
      />

      {getLightsLocations?.map((unit: any, i: number) => {
        return (
          <MyPolyLine
            key={unit.id}
            // @ts-ignore
            unit={unit}
          />
        )
      })}

      {dataUnits?.data?.data?.map((unit: any) => (
        <Placemark
          key={unit.id}
          defaultGeometry={unit.coordinates}
          options={{
            iconLayout: 'default#image',
            iconImageSize: [30, 30],
            iconImageHref: getIconForUnit(unit),
          }}
        />
      ))}

      {/* Отображение статичных линий */}
      {finalStaticPolylines.map((polyline, index) => {
        // console.log(888, polyline)
        return (
          <Polyline
            key={`static-line-${index}`}
            geometry={polyline.coordinates}
            options={{
              strokeColor: getLineColor(polyline.lightingTypeId),
              strokeWidth: 4,
              strokeOpacity: 0.7,
            }}
          />
        )
      })}

      {/* Отображение редактируемой линии */}
      {coordinates.length > 1 && (
        <Polyline
          geometry={coordinates}
          options={{
            strokeColor: getLineColor(typeId),
            strokeWidth: 4,
            strokeOpacity: 0.9,
          }}
        />
      )}

      {/* Отображение точек редактируемой линии */}
      {!disabled &&
        coordinates.map((coord, index) => (
          <Placemark
            key={`editable-point-${index}`}
            geometry={coord}
            options={{
              preset: 'islands#blueCircleDotIcon',
              iconColor: getLineColor(typeId),
              draggable: true,
            }}
            onClick={() => handlePlacemarkClick(index)}
            instanceRef={(ref: any) => {
              if (ref) {
                ref.events.add('dragend', () => {
                  const newCoords = ref.geometry.getCoordinates()
                  handleDragEnd(index, newCoords)
                })
              }
            }}
          />
        ))}
    </Map>
  )
}

export default MapLightnings
